









































import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {},
  props: {
      toHome: Number,
      toBattery: Number, 
      consumedHome: Number,  
      fromSolar: Number,
      toGrid: Number,
  }
})

export default class EnergyFlow extends Vue {
    private toHome: number;
    private toBattery: Number;
    private consumedHome: Number;
    private fromSolar: Number;
    private toGrid: Number;

    fixLine(from: string, to: string, theline: string, isLine: boolean, x: number){
        const node1 = document.getElementById(from);
        const node2 = document.getElementById(to);
        const line = document.getElementById(theline);
        
        if (node1 && node2 && line){
            let x1 = node1.offsetLeft + node1.offsetWidth/2 + node1.getElementsByTagName('img')[0].offsetWidth;
            let y1 = node1.offsetTop + node1.offsetHeight/2;

            let x2 = node2.offsetLeft + node2.offsetWidth/2 - node2.getElementsByTagName('img')[0].offsetWidth;
            let y2 = node2.offsetTop + node2.offsetHeight/2;

            let w = x2 - x1;
            let h = y2 - y1;

            let sx = w/352;
            let sy = h/92;

            if (isLine){
                line.setAttribute('x1', x1.toString());
                line.setAttribute('x2', x2.toString());
                line.setAttribute('y1', y1.toString());
                line.setAttribute('y2', y2.toString());

                const arrows = document.getElementsByClassName('cls-' + x);
                
                y1 -= 4;
                x1 += node1.offsetWidth/4-20;

                if (arrows){
                    [].forEach.call(arrows, function (arrow: any) {
                        arrow.setAttribute('transform', 'translate(' + x1 +',' + y1 + ') scale(' + sx + ',' + 0.6 + ')');
                    });
                }
            } else {
                line.setAttribute('transform', 'translate(' + x1 +',' + y1 + ') scale(' + sx + ',' + sy + ')');
                const arrows = document.getElementsByClassName('cls-' + x);

                if (arrows){
                    [].forEach.call(arrows, function (arrow: any) {
                        arrow.setAttribute('transform', 'translate(' + x1 +',' + y1 + ') scale(' + sx + ',' + sy + ')');
                    });
                }
            }
        }
    }
    
    fixLines (){
        if (this.toBattery !== 0){
            this.fixLine('solar', 'home', 'solartohome', false, 3);
        } else {
            this.fixLine('solar', 'home', 'solartohome', true, 3);
        }
        this.fixLine('battery', 'home', 'batterytohome', false, 2);
        this.fixLine('home', 'grid', 'gridtohome', true, 4);
        
        if (this.toBattery > 0){
            this.invertLine('batterytohome', 2);
        } 

        if (this.toGrid < 0){
               this.invertLine('gridtohome', 4);
        }
    }

    invertLine(theline: string, x: number){
        const line = document.getElementById(theline);
        
        if (line){
            if (x == -2){
                if (line.getAttribute('marker-end') == 'url(#arrow)'){
                    line.setAttribute('marker-end', 'unset');
                    line.setAttribute('marker-start', 'url(#arrow)');
                } else {
                    line.setAttribute('marker-start', 'unset');
                    line.setAttribute('marker-end', 'url(#arrow)');
                }
            } else {
                const arrows = document.getElementsByClassName('cls-' + x);

                const node1 = document.getElementById('solar');
                const node2 = document.getElementById('battery');
                
                if (node1 && node2){
                    let x1 = node1.offsetLeft + node1.offsetWidth/2 + node1.getElementsByTagName('i')[0].offsetWidth;
                    let y1 = node1.offsetTop + node1.offsetHeight/2;

                    let x2 = node2.offsetLeft + node2.offsetWidth/2 - node2.getElementsByTagName('i')[0].offsetWidth;
                    let y2 = node2.offsetTop + node2.offsetHeight/2;
                    
                    if (arrows){
                        [].forEach.call(arrows, function (arrow: any) {
                            arrow.setAttribute('transform', arrow.getAttribute('transform') + ' scale(-1, 1) translate('+ (x2-x1-15) +')');
                        });
                    }
                }
            }
        } 
    }

    mounted() {
        this.$nextTick(function() {
            window.addEventListener('resize', () => this.fixLines());
            setInterval(()=>this.fixLines(), 1000);
       })


    }

    updated(){
        this.fixLines();
    }

    beforeDestroy() {
        window.removeEventListener('resize', () => this.fixLines());
    }
}

